import { IMAGES } from "@/lib/images";
import Reveal from "@/components/Reveal";

const SPANS = [
  "row-span-2", "row-span-1", "row-span-1",
  "row-span-1", "row-span-2", "row-span-1",
  "row-span-1", "row-span-1", "row-span-2",
];

export default function Portfolio() {
  return (
    <section id="work" data-testid="portfolio" className="bg-[#FAF8F5] text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <Reveal className="mb-12">
          <div className="flex items-center gap-4 mb-5">
            <span className="w-10 h-px bg-[#C5B382]" />
            <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">Portfolio</span>
          </div>
          <h2 className="font-serif text-7xl sm:text-9xl font-medium leading-[0.85] tracking-tight">The Work</h2>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-3 auto-rows-[200px] sm:auto-rows-[280px] gap-4">
          {IMAGES.portfolio.map((src, i) => (
            <Reveal key={i} delay={(i % 3) * 0.05} className={SPANS[i % SPANS.length]}>
              <div data-testid={`portfolio-${i}`} className="group relative w-full h-full overflow-hidden rounded-[1.25rem] shadow-card">
                <img src={src} alt={`Lash work ${i + 1}`} className="w-full h-full object-cover transition-transform duration-[1000ms] ease-out group-hover:scale-110" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
